import React, { Component } from 'react';
import PropTypes from 'prop-types';
import serialize from 'form-serialize';

import Validator from '../helpers/validation';
import CustomSelect from '../components/CustomSelect';

const schema = [
	{
		name: 'fio',
		fieldName: 'Имя',
		rules: 'required|alphaSymbols'
	},
	{
		name: 'username',
		fieldName: 'Логин',
		rules: 'required|custom',
		customRule: value => /^[A-Za-z0-9_-]+$/.test(value),
		errorMessage: 'Поле Логин может содержать только латинские буквы, цифры и символы: _-.'
	},
	{
		name: 'role',
		fieldName: 'Сотрудник',
		rules: 'required'
	},
	{
		name: 'phone',
		fieldName: 'Телефон',
		rules: 'required'
	},
	{
		name: 'email',
		fieldName: 'Почта',
		rules: 'required|email'
	}
];

class AddUserForm extends Component {
	constructor (props) {
		super(props);

		this.state = {
			submitErrors: [],
			values: props.user || {
				role: ''
			}
		}
	}

	componentWillReceiveProps (nextProps) {
		if (nextProps.user && this.props.user !== nextProps.user) {
			this.setState({
				submitErrors: [],
				values: nextProps.user
			});
		}
	}

	componentDidMount () {
		this.validator = new Validator(this.form, schema);
	}

	onSubmit = e => {
		e.preventDefault();
		const validation = this.validator.validateForm();

		if (validation.valid) {
			const data = serialize(this.form, {hash: true});
			this.props.onSubmit({...data, ...this.state.selectsValues});
			if (!this.props.user) {
				this.form.reset();
				this.setState({
					submitErrors: [],
					values: {
						role: ''
					}
				});
			}
		} else {
			this.setState({
				submitErrors: validation.errors
			});
		}
	}

	onSelectChange = (name, value) => {
		this.setState(prevState => ({
			values: {
				...prevState.values,
				[name]: value
			}
		}));
	}

	handleInputChange = e => {
		const { value, name } = e.target;

		this.setState(prevState => ({
			values: {
				...prevState.values,
				[name]: value
			}
		}));
	}

	componentWillUnmount () {
		this.props.clearErrors();
	}

	render () {
		const { selectData, user } = this.props;
		const { values } = this.state;

		return (
			<form action="" method="" ref={c => this.form = c} className="custom-form mr-bottom-40 clearfix">
				<h3 className="text-center">{user ? 'Редактировать сотрудника' : 'Добавить сотрудника'}</h3>
				<input type="hidden" name="id" value={values.id} />
				{this.state.submitErrors.length || this.props.serverError ?
					<div className="alert alert-danger" role="alert">
						{this.state.submitErrors.map((error, key) => <div key={`error_${key}`}>{error}</div>)}
						{this.props.serverError}
					</div> : null
				}
				{
					!selectData ?
						null :
						<div>
							<div className="row">
								<div className="col-xs-6">
									<div className="col-xs-3 custom-form__label">Имя</div>
									<div className="col-xs-5">
										<input type="text" className="custom-form__input" value={values.fio} name="fio" onChange={this.handleInputChange} />
									</div>
								</div>
								<div className="col-xs-6">
									<div className="col-xs-3 custom-form__label">Пароль</div>
									<div className="col-xs-5">
										<input type="password" className="custom-form__input" value={values.password} name="password" onChange={this.handleInputChange} />
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-xs-6">
									<div className="col-xs-3 custom-form__label">Логин</div>
									<div className="col-xs-5">
										<input type="text" className="custom-form__input" value={values.username || values.login} name="username" onChange={this.handleInputChange} />
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-xs-6">
									<div className="col-xs-3 custom-form__label">Сотрудник</div>
									<div className="col-xs-5">
										<input type="hidden" name="role" ref={c => this.role = c} value={values.role} />
										<CustomSelect
											placeholder="Выберите тип"
											options={selectData.roles}
											name="role"
											onSelect={this.onSelectChange}
											values={values.role}
										/>
									</div>
								</div>
								<div className="col-xs-6">
									<div className="col-xs-3 custom-form__label">Телефон</div>
									<div className="col-xs-5">
										<input type="text" className="custom-form__input" name="phone" value={values.phone} onChange={this.handleInputChange} />
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-xs-6">
									<div className="col-xs-3 custom-form__label">Почта</div>
									<div className="col-xs-5">
										<input type="email" className="custom-form__input" name="email" value={values.email} onChange={this.handleInputChange} />
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-xs-6">
									<button className="col-xs-5 btn btn-success mr-right-xs-3 pull-right" type="submit" onClick={this.onSubmit}>
										{user ? 'Сохранить' : 'Добавить'}
									</button>
								</div>
							</div>
						</div>
				}
			</form>
		);
	}
}

AddUserForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	serverError: PropTypes.string,
	selectData: PropTypes.object,
	user: PropTypes.object,
	clearErrors: PropTypes.func
}

export default AddUserForm;



// WEBPACK FOOTER //
// ./components/AddUserForm.js